<template>
  <RuesBoxSize :size="props.item?.width ?? 12" :class="['flex flex-row gap-4 items-center justify-center lg:justify-start mt-[-20px]']">
    <div v-if="showTrustpilot" class="relative overflow-hidden lg:hidden flex items-center h-[60px] w-full">
      <div
        class="absolute w-full flex justify-center wrap-break-word transition-transform duration-500 ease-in-out"
        :class="activeSlide === 0 ? 'translate-x-0' : '-translate-x-full'"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div class="start-vsm-min-trustpilot lg:max-w-[120px] max-h-[54px] overflow-hidden" v-html="props.trustpilotBox" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <div
        class="absolute w-full flex justify-center wrap-break-word transition-transform duration-500 ease-in-out"
        :class="activeSlide === 1 ? 'translate-x-0' : 'translate-x-full'"
      >
        <a
          href="https://www.deutscher-ferienhausverband.de/zertifikat/travanto/"
          target="_blank"
          rel="nofollow"
          class="flex flex-row gap-2 text-left items-center"
        >
          <UiIcon src="/svg/logo/dfv_siegel_umriss.svg" width="53" height="53" class="fill-[#87AA1D] inline-block" />
          <div class="font-semibold text-neutral-600 text-xs md:text-sm wrap-break-word">
            <UiLanguagePlaceholder domain="RuesTrust" name="ferienhausverband" />
          </div>
        </a>
      </div>
    </div>

    <div :class="showTrustpilot ? 'hidden lg:flex flex-row gap-4 items-center' : 'flex flex-row gap-4 items-center'">
      <div v-if="showTrustpilot" class="wrap-break-word max-w-full">
        <!-- eslint-disable vue/no-v-html -->
        <div class="start-vsm-min-trustpilot w-[120px] max-h-[54px] overflow-hidden" v-html="props.trustpilotBox" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <div class="wrap-break-word max-w-full">
        <a
          href="https://www.deutscher-ferienhausverband.de/zertifikat/travanto/"
          target="_blank"
          rel="nofollow"
          class="flex flex-row gap-2 text-left items-center"
        >
          <UiIcon src="/svg/logo/dfv_siegel_umriss.svg" width="53" height="53" class="fill-[#87AA1D] inline-block" />
          <div class="font-semibold text-neutral-600 text-xs md:text-sm wrap-break-word">
            <UiLanguagePlaceholder domain="RuesTrust" name="ferienhausverband" />
          </div>
        </a>
      </div>
    </div>
  </RuesBoxSize>
</template>

<script setup lang="ts">
import { isMasurenPortal } from '~/utils/isMasurenPortal'

const props = defineProps({
  item: {
    type: Object,
    default: null
  },
  trustpilotBox: {
    type: String,
    default: null
  }
})

const activeSlide = ref(0)
let slideInterval: ReturnType<typeof setInterval> | null = null

const { currentPortal } = usePortals()

onMounted(() => {
  if (!isMasurenPortal(currentPortal.value?.portal?.portal)) {
    const script = document.createElement('script')
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.sync.bootstrap.min.js'
    script.async = true
    document.body.appendChild(script)
  }

  if (showTrustpilot.value) {
    slideInterval = setInterval(() => {
      activeSlide.value = activeSlide.value === 0 ? 1 : 0
    }, 5000)
  }
})

onUnmounted(() => {
  if (slideInterval) {
    clearInterval(slideInterval)
    slideInterval = null
  }
})

const showTrustpilot = computed(() => !!props.trustpilotBox)
</script>

<style scoped>
@reference "~/assets/css/main.css";
  .rues-trust-column-welt{
    @apply w-full h-auto max-w-[150px] md:w-[153px] md:max-w-full;
  }
  :deep(.trustpilot-widget) {
    @apply mt-3 lg:-mt-4
  }
</style>
